import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import { SubTab, SubInput } from "./TabNInput";
import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { Input, SubmitButton } from "../Form/Form";
import { compareChanges } from "../../util/fn";
import { CHANGES_REQ_MESSAGE } from "../../util/other";


const Edit = (props) => {
  const { id: cmsId } = props.match.params;

  const [languages, setLanguages]                                   = useState([]);
  const [ckcontent, setCkContent]                                   = useState();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    trigger,
    getValues,
    reset,
    setError,
    clearErrors,
  } = useForm();

  const history = useHistory();

  const { response, request } = useRequest();

  const { response: responseFetchCms, request: requestFetchCms } = useRequest();
  const [oldValues, setOldValues]                     = useState([]);
  const { response: responseLanguages, request: requestLanguages } =
    useRequest();

  useEffect(() => {
    requestLanguages("GET", "admin/languages");
    document.title = "Edit CMS - Calevalab";
    register(`description-en`, { required: true });
  }, []);

  useEffect(() => {
    if (responseLanguages) {
      const { languages } = responseLanguages;

      languages.forEach((lang) => {
        if (lang.default) {
          register(`description-${lang.code}`, { required: true });
        } else {
          register(`description-${lang.code}`);
        }
      });

      requestFetchCms("GET", `cms/${cmsId}`);

      setLanguages(languages);
    }
  }, [responseLanguages]);

  useEffect(() => {
    if (responseFetchCms) {
      const {
        data: { name },
        languageData,
      } = responseFetchCms.cms[0];
      const subData = {};

      languageData.forEach((lang) => {
        setCkContent(lang.description)
        const code = lang.languageCode;
        subData["title-" + code] = lang.title;
        subData["description-" + code] = lang.description;
        subData["id-" + code] = lang?.id;
      });

      reset({ name, ...subData });

      const langDataWithoutId = languageData.map(({ id, ...rest }) => rest);
      const langDataShortedOld = langDataWithoutId.sort((a, b) => a.languageCode.localeCompare(b.languageCode));
      setOldValues({
        langData:langDataShortedOld
      });
    }
  }, [responseFetchCms]);

  useEffect(() => {
    if (response) {
      toast.success("CMS Page has been updated successfully.");
      history.push("/cms");
    }
  }, [response]);

  const onSubmit = (data) => {
    const dataToSend = [];
    const defaultData = { name: data["name"] };

    for (let i = 0; i < languages.length; i++) {
      const code = languages[i].code;
      dataToSend.push({
        title: data["title-" + code] ?? "",
        description: data["description-" + code] ?? "",
        languageCode:code,
        id: data[`id-${code}`] || "",
      });

      if (languages[i].default) {
        defaultData.title = data["title-" + code];
        defaultData.description = data["description-" + code];
        if (data["description-" + code].length === 0) {
          setError("description-" + code, {
            type: "required",
          });
          return;
        }
      }
    }


    const langDataWithoutId = dataToSend.map(({ id, ...rest }) => rest);
    const langDataShorted = langDataWithoutId.sort((a, b) => a.languageCode.localeCompare(b.languageCode));

    let newData = {
      langData:langDataShorted
    };
    if(compareChanges(oldValues,newData)){
      request("PUT", "cms", { id: cmsId, ...defaultData, data: dataToSend });
    }
    else {
      toast.error(CHANGES_REQ_MESSAGE);
    }
   
  };

  const InputFields = [
    {
      Component: Input,
      label: "Page Name",
      type: "text",
      name: "name",
      registerFields: {
        required: true,
      },
      inputData: { readOnly: true },
    },
  ];

  return (
    <div
      className="content  d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Breadcrumb
        title="Edit CMS Page"
        links={[
          { to: "/", name: "Dashboard" },
          { to: "/cms", name: "Back To CMS Page" },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="card card-custom gutter-b">
              <div className="card-body">
                <div className="row">
                  {InputFields.map((Input, index) => (
                    <Input.Component
                      key={index}
                      {...Input}
                      errors={errors}
                      register={register}
                    />
                  ))}
                </div>
              </div>
            </div>

            <div className="card card-custom gutter-b">
              <div className="card-header card-header-tabs-line">
                <div className="card-toolbar">
                  <ul
                    className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                    role="tablist"
                  >
                    {languages.length > 0 &&
                      languages.map((lang, index) => (
                        <SubTab
                          key={index}
                          name={lang.name}
                          index={index}
                          image={lang?.image}
                        />
                      ))}
                  </ul>
                </div>
              </div> 

              <div className="card-body px-0">
                <div className="tab-content px-10">
                  {languages.length > 0 &&
                    languages.map((lang, index) => (
                      <SubInput
                        key={index}
                        index={index}
                        errors={errors}
                        register={register}
                        getValues={getValues}
                        setValue={setValue}
                        trigger={trigger}
                        required={true}
                        titleName={"title-" + lang.code}
                        descName={"description-" + lang.code}
                        clearErrors={clearErrors}
                        isEdit={true}
                        ckcontent={ckcontent}
                      />
                    ))}
                </div>

                <SubmitButton
                  handleSubmit={handleSubmit}
                  onSubmit={onSubmit}
                  name="Update"
                  pxClass="px-10"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Edit;
